module.exports = "/_next/static/pages/test-guidelines/a8e8610133608b7fb822ab44fda9f818.png";